import {put, takeEvery, all, select, call} from 'redux-saga/effects'
import {
  getBoard,
  getSettings,
} from '../helpers/selectors'
import {
  getActiveOption,
  getPOCTableCards,
  isPlayersCardsCountEqual,
  isReadyToCalculateOdds,
  tableFlopValidation,
  transformCardToService,
} from '../helpers/common'
import axios from 'axios'
import {transformPlayersFromServer} from '../helpers/transformers'
import {
  CALCULATE_ODDS,
  SET_BOARD_CAROUSEL,
  SET_BOARD_PLAYERS,
  SHOW_HINT,
} from '../constants/actionTypes'
import {gameIdToApiTransformer} from '../constants/cardTransformers'
import {TYPE_HINT_ERROR} from '../constants/types'

function* calculateOdds({payload: {callback}}) {
  const board = yield select(getBoard);
  const players = board.get('players').toJS();
  const table = board.get('table').toJS();
  const settings = yield select(getSettings);
  const activeGame = getActiveOption(settings.get('rules').toJS());
  const isReady = isReadyToCalculateOdds(players, table, activeGame.rules);
  if (isReady) {
    const game = gameIdToApiTransformer[activeGame.id];
    const tableParams = getPOCTableCards(table).join(',');
    const playersParams = {};
    let i = 0;
    if ((!activeGame.rules.noCommunityCards && !tableFlopValidation(table.flop))
    || (activeGame.rules.noCommunityCards && !isPlayersCardsCountEqual(players))) {
      return yield call(showError)
    }

    for (i; i < players.length; ++i) {
      playersParams['player_' + (i + 1)] = players[i].hand.filter(card => card).map((card) => {
        const transformedCard = transformCardToService(card);
        return transformedCard.rank + transformedCard.suit
      }).join(',');
    }
    const paramsForRequest = {
      ...playersParams,
    };
    if (tableParams) {
      paramsForRequest.board_cards = tableParams;
    }
    const response = yield call(() => axios.get(`https://www.pokerlistings.com/wp-json/pokerlistings/v1/poker/?game=${game}&action=odds`, {
      params: {
        ...paramsForRequest
      }
    }));

    if (response.status === 200) {
      yield put({
        type: SET_BOARD_PLAYERS, payload: {
          players: transformPlayersFromServer(players, response.data.results.players)
        }
      });
      yield put({
        type: SET_BOARD_CAROUSEL, payload: {
          hasChanged: true,
        }
      });
      if (callback) {
        callback(true);
      }
    } else {
      return yield call(showError)
    }
  } else {
    return yield call(showError)
  }
}

function* showError() {
  return yield put({
    type: SHOW_HINT, payload: {
      type: TYPE_HINT_ERROR
    }
  });
}

function* watchCalculateOdds() {
  yield takeEvery(CALCULATE_ODDS, calculateOdds)
}

export default function* rootSaga() {
  yield all([
    watchCalculateOdds()
  ])
}